import {
    ArrowRightOutlined,
    DeleteOutlined,

    // WarningOutlined
} from "@ant-design/icons";
import { List, Select, Flex } from "antd";
import classNames from "classnames";
import { FC } from "react";
import styled from "styled-components";

import styles from "./FieldsList.module.scss";

import { ImportConfiguration, ImportConfigurationFieldMapping } from "../../types/importConfiguration";
import { Description } from "../Description";
import { Title } from "../Title";

interface FieldsListProps {
    importConfiguration: ImportConfiguration
    importConfigurationFieldMappings: ImportConfigurationFieldMapping[];
    sourceProperties: any[];
    handleFieldMappingDelete: (fieldMapping: ImportConfigurationFieldMapping) => void;
    handleFieldMappingChange: (fieldMapping: ImportConfigurationFieldMapping, value: any) => void;
    sourceFieldsTitle: string;
    validationErrors?: ImportConfigurationFieldMapping[];
    validationWarnings?: ImportConfigurationFieldMapping[];
}

export const FieldsList: FC<FieldsListProps> = ({
    importConfiguration,
    importConfigurationFieldMappings = [],
    sourceProperties,
    handleFieldMappingDelete,
    handleFieldMappingChange,
    sourceFieldsTitle,
    validationErrors,
    validationWarnings
}) => {

    const items = importConfigurationFieldMappings.map((item) => ({
        key: item.id,
        label: item.sourceFieldIdentifier,
        children: 
            <div
                className={classNames(styles.listItem, {
                    [styles.error]: validationErrors?.some((error) => error.id === item.id),
                    [styles.warning]: validationWarnings?.some((warning) => warning.id === item.id),
                })}
            >
                <div className={styles.sourceField}>
                    <StyledSelect
                        size="large"
                        style={{ minWidth: "200px" }}
                        variant="borderless"
                        options={sourceProperties}
                        value={item.sourceFieldIdentifier}
                        placeholder="Select source field"
                        onSelect={(value) => handleFieldMappingChange(item, value)}
                    />
                </div>
                <ArrowRightOutlined />
                <div className={styles.destinationField}>
                    <Flex>{item.destinationFieldIdentifier}</Flex>
                    <Flex className={styles.required}>{item.externallyManaged && <div className={styles.required}/>}</Flex>
                </div>
                <div className={styles.actions}>
                    {validationErrors?.some((error) => error.id === item.id) && item.externallyManaged && <div className={styles.required}>Required field</div>}
                    {!item.externallyManaged && <div className={styles.deleteButton} onClick={() => handleFieldMappingDelete(item)} >
                        <DeleteOutlined />
                    </div>}
                </div>
            </div>,
    }));

    return (
        <List
            className={styles.root}
            footer={null}
            grid={{ gutter: 16 }}
            size="small"
            header={
                <div className={styles.listHeader} >
                    <Flex flex="1 1 50%" justify="center" vertical align="center">
                        <Title tagName="h4">{sourceFieldsTitle}</Title>
                        <Description theme="t2">{importConfiguration?.sourceIdentifier}</Description>
                    </Flex>
                    <Flex flex="1 1 50%" justify="center" vertical align="center">
                        <Title tagName="h4">Friday Reports</Title>
                        <Description theme="t2">{importConfiguration?.destinationIdentifier}</Description>
                    </Flex>
                </div>
            }
            style={{ width: "100%" }}
        >
            {items.map((item) => (
                <List.Item style={{ marginBlockEnd: 3 }}>
                    {item.children}
                </List.Item>
            ))}

        </List>
    )
};

export const StyledList = styled(List)``;

const StyledSelect = styled(Select)`
    font-weight: 500;

    .ant-select-selector {
        .ant-select-selection-item {
            color: black;
            font-weight: 400;
        }
    }

    .ant-select-arrow {
        color: black;
    }
`;